module.exports = __webpack_public_path__ + "img/20191008160209360截图20191008143429130.96bd949a.jpg";